import { useEffect, useState } from 'react';
import {
    Card,
    CardContent,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { Header } from '../Components/Shared/Header/Header';
import SkeletonComponent from '../Components/SkeletonComponent';
import axios from 'axios';
import packageInfo from '../../package.json';

function VersionsPage() {
    const noDataDefaultMessage = 'Unavailable';
    const [isLoading, setIsLoading] = useState(true);
    const [versions, setVersions] = useState([]);

    useEffect(() => {
        const fetchBackendVersion = async () => {
            try {
                const response = await axios.get('/api/health/version');

                return response.data;
            } catch (error) {
                console.error('Error fetching backend version:', error);
                return noDataDefaultMessage;
            }
        };

        const loadVersions = async () => {
            const backendVersion = await fetchBackendVersion();

            const versionData = [
                { name: 'Application', version: packageInfo.version },
                { name: 'Backend', version: backendVersion },
            ];

            setVersions(versionData);
            setIsLoading(false);
        };

        void loadVersions();
    }, []);

    return (
        <Grid item xs={12} sm={12} md={12} sx={{ mt: 2, mb: 2 }}>
            <Card component={Paper}>
                <CardContent>
                    <div className="header">
                        <Header title="Versions" />
                    </div>
                    {isLoading ? (
                        <SkeletonComponent />
                    ) : (
                        <Table aria-label="versions table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            Entity Name
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            Version
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {versions.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.name}
                                        </TableCell>
                                        <TableCell>{row.version}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}

export default VersionsPage;
